const developmentSupportServicesData = [
  {
    title: "Team Augmentation",
    description:
      "Scale teams with vetted developers, PMs, and QA, embedded with your workflows and tools.",
    bullets: ["Frontend", "Backend", "Full‑stack", "QA"],
    minHeight: 400,
  },
  {
    title: "Code Audits",
    description:
      "Review architecture and code quality for security, performance, DX, and improvement roadmap.",
    bullets: ["Security", "Performance", "DX", "Roadmap"],
    minHeight: 400,
  },
  {
    title: "CI/CD & Tooling",
    description:
      "Build CI/CD pipelines, testing suites, and preview environments to ship reliably.",
    bullets: ["GitHub Actions", "Lint/Test", "Preview", "Release"],
    minHeight: 400,
  },
  {
    title: "Documentation",
    description:
      "Create developer and ops documentation: runbooks, playbooks, onboarding guides, and diagrams.",
    bullets: ["Runbooks", "Playbooks", "Onboarding", "Diagrams"],
    minHeight: 400,
  },
  {
    title: "Project Rescue",
    description:
      "Stabilize troubled projects with hotfixes, refactors, and clear plans to deliver outcomes.",
    bullets: ["Hotfix", "Stabilize", "Refactor", "Ship"],
    minHeight: 400,
  },
  {
    title: "Support",
    description:
      "Provide ongoing support with SLAs, ticketing workflows, and roadmap‑driven enhancements.",
    bullets: ["SLAs", "Tickets", "Reports", "Roadmap"],
    minHeight: 400,
  },
  {
    title: "Architecture Guidance",
    description:
      "Offer architectural reviews, patterns, and reference implementations with ADRs and guardrails.",
    bullets: ["ADR", "Patterns", "Refs", "Guardrails"],
    minHeight: 400,
  },
  {
    title: "Testing Strategy",
    description:
      "Establish testing strategy across unit, integration, and E2E with CI gates and coverage targets.",
    bullets: ["Unit", "Integration", "E2E", "Coverage"],
    minHeight: 400,
  },
  {
    title: "Developer Experience",
    description:
      "Improve developer experience with scaffolds, CLIs, docs, and templates for faster delivery.",
    bullets: ["Scaffolds", "CLIs", "Docs", "Playbooks"],
    minHeight: 400,
  },
];

export default developmentSupportServicesData;

export const developmentSupportMaintenanceData = [
  {
    title: "Upgrades & patches",
    description:
      "We evaluate your software to identify required updates and security fixes, and swiftly apply them to your codebase. This includes compatibility checks and refinements to keep apps running smoothly.",
    image: "/assets/img/services/development-support/upgrades.svg",
  },
  {
    title: "Integration support",
    description:
      "Guidance across planning, designing, integrating, and launching new features into your existing software, including reliable API integrations for performance and legacy systems.",
    image: "/assets/img/services/development-support/integration.svg",
  },
  {
    title: "Proactive security optimisation",
    description:
      "Safeguard software from vulnerabilities and cyber attacks using security audits, hardening, and risk reduction to prevent breaches and failures.",
    image: "/assets/img/services/development-support/security.svg",
  },
  {
    title: "Monitoring & reliability",
    description:
      "Set up observability (metrics, logs, traces) and alerting to catch issues early and maintain peak performance.",
    image: "/assets/img/services/development-support/monitoring.svg",
  },
  {
    title: "Automation & efficiency",
    description:
      "Streamline workflows with CI/CD, testing automation, and scripts to reduce manual toil and speed up delivery.",
    image: "/assets/img/services/development-support/automation.svg",
  },
  {
    title: "Backup & recovery",
    description:
      "Automated backups, policy-based retention, and restore verification to protect critical data and minimize downtime.",
    image: "/assets/img/services/development-support/backup.svg",
  },
];
